import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'

class SharingForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: ''
    }

    this.email = React.createRef()
  }

  componentDidMount() {
    this.email.current.focus()
  }

  render() {
    const { email } = this.state

    const buttonClassName = classnames({
      'button--primary': true,
      'button--success': email.indexOf('@') !== -1
    })

    return (
      <div className="sharing-form">
        <input ref={this.email}
          type="text"
          className="input--light"
          value={email || ''}
          placeholder="Email"
          onChange={(e) => this.setState({email: e.target.value})} />

        <button className={buttonClassName} onClick={() => {
          this.props.createEventUser({email: this.state.email, role: 'read'})
          this.props.removeFocus()
        }}>Invite</button>
      </div>
    )
  }
}

SharingForm.propTypes = {
  removeFocus: PropTypes.func,
  createEventUser: PropTypes.func
}

SharingForm.defaultProps = {
  removeFocus: function() {},
  createEventUser: function() {}
}

export default SharingForm



// WEBPACK FOOTER //
// ./src/components/event/event-sharing/sharing-form.js